import {Image} from '@yandex-delivery/blocks/image'
import React from 'react'
import {Brand} from 'src/shared/types'

import {goAppLogo} from './assets/go-app-logo'
import {yangoAppLogo} from './assets/yango-app-logo'

export const PromoAppLogo: React.FC<{brand?: Brand}> = ({brand = Brand.Yandex}) => (
  <Image alt={brand} {...(brand === Brand.Yango ? yangoAppLogo : goAppLogo)} />
)
